import React from 'react';
import { useParams } from 'react-router-dom';

import { OrganizationApiKeys } from '@/Pages/Settings/OrganizationApiKeys';
import { OrganizationFeedbackConfigs } from '@/Pages/Settings/OrganizationFeedbackConfigs';
import { OrganizationModels } from '@/Pages/Settings/OrganizationModels';
import { OrganizationSecrets } from '@/Pages/Settings/OrganizationSecrets';
import { OrganizationShared } from '@/Pages/Settings/OrganizationShared';
import { WorkspaceMembers } from '@/Pages/Settings/components/WorkspaceMembers';

import { OrganizationResourceTags } from '../OrganizationResourceTags';
import { ApiKeysRedirect } from './ApiKeysRedirect';

const tabComponents = {
  members: WorkspaceMembers,
  apikeys: OrganizationApiKeys,
  resource_tags: OrganizationResourceTags,
  models: OrganizationModels,
  shared: OrganizationShared,
  secrets: OrganizationSecrets,
  feedbacks: OrganizationFeedbackConfigs,
};

export const WorkspaceSettingsTab: React.FC = () => {
  const { workspaceSetting: tabName } = useParams<{
    workspaceSetting: string;
  }>();

  if (!tabName || !(tabName in tabComponents)) {
    // If the tabName is invalid, do not render anything
    return null;
  }

  if (tabName === 'apikeys') {
    return <ApiKeysRedirect />;
  }

  const TabComponent = tabComponents[tabName as keyof typeof tabComponents];

  return <TabComponent />;
};
